import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const CookiePolicy = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  // Get current date for the "Last updated" field
  const currentDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar />
      
      <div className="flex-grow pt-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Cookie Policy</h1>
          <p className="text-gray-600 mb-6"><strong>Last updated:</strong> {currentDate}</p>

          <p className="mb-6">
            This Cookie Policy explains how Bit Mentors Inc. ("we", "our", or "us") uses cookies and 
            similar tracking technologies on the Link Spaghetti website and services ("Service"). 
            By using our Service, you consent to our use of cookies as described below.
          </p>

          <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">1. What Are Cookies?</h2>
          <p className="mb-6">
            Cookies are small text files stored on your device (computer, smartphone, or other device) 
            by your web browser when you visit websites. They help websites recognize your device and 
            remember information about your visit.
          </p>

          <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">2. Types of Cookies We Use</h2>
          <ul className="list-disc pl-8 mb-6 space-y-2">
            <li><strong>Essential Cookies:</strong> These cookies are necessary for the website to function properly. They enable core features like security, page navigation, and access to secure areas.</li>
            <li><strong>Analytics Cookies:</strong> We use Google Analytics cookies to collect information about how visitors use our Service, such as pages visited, time spent, and traffic sources. This helps us improve the Service and understand user behavior.</li>
            <li><strong>Marketing Cookies:</strong> Cookies used to deliver relevant marketing and promotional messages to users based on their interests and interactions with our Service.</li>
          </ul>

          <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">3. How We Use Cookies</h2>
          <p className="mb-4">Cookies help us:</p>
          <ul className="list-disc pl-8 mb-6 space-y-2">
            <li>Remember your preferences and settings.</li>
            <li>Understand how you use our Service to improve its performance and user experience.</li>
            <li>Provide targeted advertising and marketing communications.</li>
          </ul>

          <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">4. Managing Cookies</h2>
          <p className="mb-4">
            You can control or disable cookies through your browser settings. Most browsers allow you 
            to refuse or delete cookies. However, disabling cookies may affect your ability to use 
            certain features of our Service.
          </p>
          <p className="mb-6">
            For detailed instructions on managing cookies, visit{' '}
            <a 
              href="https://www.aboutcookies.org/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-purple-600 hover:text-purple-800"
            >
              aboutcookies.org
            </a>.
          </p>

          <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">5. Third-Party Cookies</h2>
          <p className="mb-4">
            We may allow third-party service providers, such as Google Analytics and advertising partners, 
            to place cookies on your device. These third parties may collect information about your online 
            activities over time and across different websites.
          </p>
          <p className="mb-6">
            We do not control these cookies and recommend reviewing the privacy policies of these third 
            parties for more information.
          </p>

          <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">6. Changes to This Cookie Policy</h2>
          <p className="mb-6">
            We may update this Cookie Policy periodically to reflect changes in our practices or legal 
            requirements. We encourage you to review this page regularly for updates.
          </p>

          <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">7. Contact Us</h2>
          <p className="mb-4">
            If you have any questions or concerns about our use of cookies, please contact us at:
          </p>
          <p className="mb-6">
            <strong>Email:</strong> <a href="mailto:support@linkspaghetti.com" className="text-purple-600 hover:text-purple-800">support@linkspaghetti.com</a><br />
            <strong>Address:</strong> Bit Mentors Inc., Ottawa, Canada
          </p>

          <div className="mt-12 pt-6 border-t border-gray-200 text-center text-gray-500 text-sm">
            &copy; {new Date().getFullYear()} Bit Mentors Inc. All rights reserved.
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default CookiePolicy;
